import { render, staticRenderFns } from "./MyPageAuction.vue?vue&type=template&id=64662450&scoped=true"
import script from "./MyPageAuction.vue?vue&type=script&lang=js"
export * from "./MyPageAuction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64662450",
  null
  
)

export default component.exports